import React from 'react';
import classes from './Main.module.css';
import AboutMe from '../components/AboutMe/AboutMe';
import MainDesktop from '../assets/main.svg';
import MainMobile from '../assets/main-mobile.svg';
import { useWindowWidth } from '../hooks';

const Main = () => {

	const width = useWindowWidth();

	let mainImg = <img className={classes.Overlay} src={MainDesktop} alt= "" />;

	if (width < 1050) {
		mainImg = <img className={classes.Overlay} src={MainMobile} alt = ""/>;
	}

	return (
		<div className={classes.Main}>
			<header>
				<div className={classes.MainHeader}>{mainImg}</div>
				<div className={classes.AboutMeContainer}>
					<h1>Hello World</h1>
					{' '}
				</div>
			</header>

			<div className={classes.AboutMe} id='about-me'>
				<AboutMe />
			</div>

		</div>
	);
};

export default Main;
